import { getCurrentConference } from '../base/conference';
import { getLocalParticipantId, getPinnedParticipantIds, getSortedLayoutParticipant, getSortedPinnedParticipantsByStatus, getSortedRemoteParticipantsByStatus } from '../base/participants';
import { isChatOpen } from '../chat';
import { setRemoteParticipants } from './actions';
import { videoLayoutMode } from './constants';

export function getVisibleParticipantCount(state) {
    const {visibleRemoteParticipants} = state['features/video-layout-mode'];

    if (visibleRemoteParticipants) return visibleRemoteParticipants.size;
}

export function getLayoutWidthAndHeight(state) {
    let { layoutWidth, layoutHeight, isShowArrow } = state['features/video-layout-mode'];
    const rightMenu = isChatOpen(state) || state["features/participant-right"].isOpen;

    const { prev, next, isVertical } = isShowArrow;

    if (!isVertical) {
        layoutWidth = layoutWidth - (prev ? 30 : 0) - (next ? 30 : 0);
    } else {
        layoutHeight = layoutHeight - (prev ? 30 : 0) - (next ? 30 : 0);
    }
    
    if (rightMenu) layoutWidth = layoutWidth - 330;

    return { layoutWidth, layoutHeight };    
}

export function getGirdColumns(count) {
    const rows = Math.round(Math.sqrt(count));
    const alpha = count - rows * rows;

    const plus = alpha > 0 ? 1 : 0;
    const columns = rows + plus;

    return columns;
}

export function getGirdRows(count) {
    const rows = Math.round(Math.sqrt(count));
    return rows;
}
export function getVisibleCount(state) {
    const { visibleParticipantsStartIndex, visibleParticipantsEndIndex } = state['features/video-layout-mode'];
    return visibleParticipantsEndIndex - visibleParticipantsStartIndex;
}

export function updateRemoteParticipants({ dispatch, getState }) {
    try {
        const state = getState();
        if (!getCurrentConference(state)) return;

        let reorderedParticipants = [];
        const { includePin, remoteParticipants } = state['features/video-layout-mode'];

        const remote = getSortedLayoutParticipant(state, includePin);
        reorderedParticipants = remote.map(value => value.user_uuid);
        
        dispatch(setRemoteParticipants(reorderedParticipants));
    } catch (err) {
        console.log(err)
    }    
}

export function updateRemoteParticipantsOnLeave(store, participantId = null) {
    if (!participantId) return;

    const state = store.getState();
    const { remoteParticipants } = state['features/video-layout-mode'];
    
    const reorderedParticipants = new Set(remoteParticipants);
    if (reorderedParticipants.has(participantId)) {
        
        reorderedParticipants.delete(participantId) &&
            store.dispatch(
                setRemoteParticipants(Array.from(reorderedParticipants)),
            );
    }
}

export function isPropertyOpen(state, compareMode) {
    const mode = getCurrentMode(state);
    return mode === compareMode ? true : false;
}

export function getAutoPinSetting() {
    return typeof interfaceConfig === 'object'
        ? interfaceConfig.AUTO_PIN_LATEST_SCREEN_SHARE
        : 'remote-only';
}

export function getGridVisibleCount(state) {
    const { gridCount } = state['features/video-layout-mode'];

    return gridCount;
}

export function getFilmStyle(state, count, half) {
    const mode = getCurrentMode(state);
    
    let { layoutWidth, layoutHeight } = getLayoutWidthAndHeight(state);
    if (half) layoutWidth = layoutWidth / 2;
    
    const columns = getGirdColumns(count);
    const rows = getGirdRows(count);

    if (mode === videoLayoutMode.pin || mode === videoLayoutMode.voice) {
        const { remote } = state['features/base/participants'];
        const pinnedParticipantIds = getPinnedParticipantIds(state);
        const localId = getLocalParticipantId(state);
        
        let minusHeight = 104;
        if (mode === videoLayoutMode.pin 
            && remote.size < 1
            && pinnedParticipantIds.indexOf(localId) !== -1) minusHeight = 0;
        if (mode === videoLayoutMode.voice && remote.size < 1) minusHeight = 0;
        
        layoutHeight = layoutHeight - minusHeight;
    }

    layoutWidth = layoutWidth / columns;
    layoutHeight = layoutHeight / rows;

    let width = layoutWidth;
    let height = (9 * width) / 16;

    if (Math.floor(layoutHeight / height) < rows && layoutHeight < height) {
        height = layoutHeight;
        width = (16 * height) / 9;
    }

    return { width, height };
}

export function getCurrentMode(state) {
    const mode = state['features/video-layout-mode'].mode;
    const viewVisible = state['features/video-layout-mode'].viewVisible;

    return checkLayoutMode(mode, viewVisible);
}

export function checkLayoutMode(mode, viewVisible) {
    let currentMode = mode;
    try {
        if (viewVisible[videoLayoutMode.screen]) currentMode = videoLayoutMode.screen;
        if (viewVisible[videoLayoutMode.white]) currentMode = videoLayoutMode.white;
        if (viewVisible[videoLayoutMode.document]) currentMode = videoLayoutMode.document;
        if (viewVisible[videoLayoutMode.vod]) currentMode = videoLayoutMode.vod;
        if (viewVisible[videoLayoutMode.note]) currentMode = videoLayoutMode.note;
    } catch {}
    

    return currentMode;
}

export function getPreviewMode(state) {
    return state['features/video-layout-mode'].prevLayoutMode;
}